import React from 'react';
import { Avatar, Row, Col, Typography, Tag, theme } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';

const PlayerProfileHeader = ({
  photoURL,
  nickname,
  age,
  position,
  level,
  city,
  email,
  phone,
  topRight,
}) => {
  const { token } = theme.useToken();
  return (
    <div
      style={{
        position: 'relative',
        borderRadius: token.borderRadiusLG,
        overflow: 'hidden',
        marginBottom: 20,
        border: `1px solid ${token.colorBorderSecondary}`,
      }}>
      {/* Gradient strip */}
      <div
        style={{
          height: 72,
          background: `linear-gradient(135deg, ${token.colorPrimary}cc 0%, ${token.colorPrimary}44 100%)`,
        }}
      />

      {/* Top-right slot — edit button, close button, etc. */}
      {topRight && (
        <div style={{ position: 'absolute', top: 8, right: 8 }}>
          {topRight}
        </div>
      )}

      {/* Avatar overlapping the gradient strip */}
      <Row justify="center" style={{ marginTop: -36 }}>
        <Avatar
          size={88}
          src={photoURL}
          style={{
            border: `3px solid ${token.colorBgContainer}`,
            boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
          }}
        />
      </Row>

      {/* Name + optional contact info + attribute tags */}
      <div style={{ textAlign: 'center', padding: '10px 16px 16px' }}>
        <Typography.Title level={5} ellipsis style={{ margin: '0 0 2px' }}>
          {nickname}
        </Typography.Title>
        {email && (
          <Typography.Text
            type="secondary"
            style={{ fontSize: 12, display: 'block' }}>
            {email}
          </Typography.Text>
        )}
        {phone && (
          <Typography.Text
            type="secondary"
            style={{ fontSize: 12, display: 'block' }}>
            {phone}
          </Typography.Text>
        )}
        {(age || position || level || city) && (
          <Row justify="center" gutter={[4, 4]} style={{ marginTop: 8 }}>
            {age && (
              <Col>
                <Tag style={{ borderRadius: 20, margin: 0 }}>{`${age} años`}</Tag>
              </Col>
            )}
            {position && (
              <Col>
                <Tag color="blue" style={{ borderRadius: 20, margin: 0 }}>
                  {position}
                </Tag>
              </Col>
            )}
            {level && (
              <Col>
                <Tag color="green" style={{ borderRadius: 20, margin: 0 }}>
                  {level}
                </Tag>
              </Col>
            )}
            {city && (
              <Col>
                <Tag icon={<EnvironmentOutlined />} style={{ borderRadius: 20, margin: 0 }}>
                  {city}
                </Tag>
              </Col>
            )}
          </Row>
        )}
      </div>
    </div>
  );
};

export default PlayerProfileHeader;
